// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + "CodeEditor" + "." + "f05dc2042b69fc8e93c0" + ".chunk.js";
};